import React from 'react';
import PropTypes from 'prop-types';
import {
  Components, Theme, Utils, translate,
} from 'versafleet-core';
import moment from 'moment';

const MobileGlobalSearchItem = ({
  data = null,
  isJob = false,
  strings,
  onClick,
}) => {
  if (Utils.Helper.isNullOrUndefined(data)) {
    return (
      <div className="vf-mobile-global-search__item vf-mobile-global-search__item--no-item">
        {strings.emptyItem}
      </div>
    );
  }

  let title;
  let subtitle;
  let taskIcon;

  if (isJob) {
    title = data.guid;
    subtitle = `${data.task_summary.task_count} ${data.job_type.charAt(0).toUpperCase() + data.job_type.slice(1)} Tasks`;
  } else {
    taskIcon = data.job.job_type === 'delivery' ? 'arrow-down' : 'arrow-up';
    if (data.billing_account != null) {
      title = data.billing_account.name;
      subtitle = data.guid;
    } else if (data.address.contact_person != null) {
      title = data.address.contact_person;
      subtitle = data.guid;
    } else {
      title = data.guid;
      subtitle = `of ${data.job.guid}`;
    }
  }

  return (
    <div
      className="vf-mobile-global-search__item"
      onClick={() => onClick(data)}
    >
      <div className="vf-mobile-global-search__item__container">
        <Components.CircleIcon
          className="vf-mobile-global-search__item__container__icon"
          iconClassName={isJob ? `versa-base-${data.job_type}`
            : `versa-${taskIcon}`}
          innerIconColor={Theme.Color.$text}
          outerIconColor={Theme.Color.$bluelighter2}
        />

        <div className="vf-mobile-global-search__item__container__content">
          <div className="vf-mobile-global-search__item__container__content--title">
            {title}
          </div>
          <div className="vf-mobile-global-search__item__container__content--subtitle">
            {subtitle}
          </div>
        </div>

        <div className="vf-mobile-global-search__item__container__date">
          {isJob ? moment(data.base_task.time_from).format('DD MMM YYYY') : moment(data.time_from).format('DD MMM YYYY')}
        </div>
      </div>
    </div>
  );
};

MobileGlobalSearchItem.displayName = 'Mobile Global Search Item';

MobileGlobalSearchItem.propTypes = {
  data: PropTypes.shape(),
  isJob: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  strings: PropTypes.shape({
    emptyItem: PropTypes.string,
  }).isRequired,
};

export default translate('GlobalSearch')(MobileGlobalSearchItem);
